(() => {
  const popup = document.getElementById('LiyaExitPopup');
  if (!popup) return;

  const STORAGE_KEY = 'liyaExitPopupSuppressedUntil';
  const alreadySubscribed = popup.dataset.alreadySubscribed === 'true';

  const isSuppressed = () => {
    const until = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
    return Date.now() < until;
  };

  const suppressFor = (days) => {
    localStorage.setItem(STORAGE_KEY, String(Date.now() + days * 24 * 60 * 60 * 1000));
  };

  const show = () => {
    popup.classList.add('is-visible');
  };

  const hide = () => {
    popup.classList.remove('is-visible');
    suppressFor(3);
  };

  popup.querySelector('#LiyaExitPopup-close')?.addEventListener('click', hide);

  popup.addEventListener('click', (event) => {
    if (event.target === popup) hide();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('is-visible')) hide();
  });

  if (alreadySubscribed) {
    suppressFor(90);
    window.requestAnimationFrame(show);
    return;
  }

  if (isSuppressed()) return;

  let armed = false;
  const arm = () => {
    armed = true;
  };
  window.setTimeout(arm, 4000);

  const trigger = () => {
    if (!armed || popup.classList.contains('is-visible')) return;
    show();
  };

  document.addEventListener('mouseleave', (event) => {
    if (event.clientY <= 0) trigger();
  });

  // Mobile fallback: no mouseleave signal, so use a dwell-time trigger instead.
  window.setTimeout(trigger, 25000);
})();
